export const getSystemConfig = () => {
	//  console.info("angular scope", angular.element(document.getElementsByTagName("body")).scope());
	return fetch("./configFile.js?v=2").then(response => response.text()).then(text => {
		console.info("config text", text);
		let json = text.substr(text.indexOf("{"));
		json = json.substr(0, json.indexOf("}") + 1);
		let str = "(" + json + ")";
		// eslint-disable-next-line no-eval
		json = eval(str);
		return json;
		// this.serverLink = json.serverUrl;
		// this.LSM.serverLink = json.serverUrl;
	});
};
